import { ImageSpinner } from '@ui-framework/index';
import { AI_IMAGE_FILE } from './constants';

function AiLoader(props) {
  const size = props?.size || 50;
  const speed = props?.speed || 1.2;
  return (
    <ImageSpinner
      src={AI_IMAGE_FILE}
      size={size}
      speed={speed}
      pauseOnHover={false}>
      {props?.children}
    </ImageSpinner>
  );
}

export default AiLoader;
